import React, { useState, useEffect } from 'react';
import { db, storage } from '../../../utils/firebase-config';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, updateDoc, getDoc, collection, addDoc, getDocs } from "firebase/firestore";
import { surveySteps } from "../Questions/Questions";
import StepHeader from '../StepHeader';
import SavedAnswersPage from './SavedAnswersPage/SavedAnswersPage';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import AreaNavigator from '../userProgressTrack/AreaNavigator';
import generatePDF from '../../PdfGenerator/PdfGenerator'; // Import the PDF generation function
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faFileEdit, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
import updateUserProgress from '../userProgressTrack/updateUserProgress'; // Import the update function if not already imported

const CommunityForm = ({ currentStepData, userId, handleNextStep, currentStep, handlePreviousStep, setCurrentStep, progress, area }) => {
  const [file, setFile] = useState(null);
  const [showReviewPopup, setShowReviewPopup] = useState(false);
  const [highlightedQuestion, setHighlightedQuestion] = useState(null);
  const [highlightColor, setHighlightColor] = useState('');
  const [formValues, setFormValues] = useState({});
  const [savedAnswers, setSavedAnswers] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formReset, setFormReset] = useState(false); // New state to handle form reset
  //const [submissionId, setSubmissionId] = useState(null); // New state for unique submission ID
  const [submissionId, setSubmissionId] = useState(localStorage.getItem('currentSubmissionId')); // Retrieve from localStorage
  const navigate = useNavigate(); // Initialize useNavigate
  const [logoURL, setLogoURL] = useState(null);


  // useEffect(() => {
  //   const fetchSavedAnswers = async () => {
  //     if (formReset) return;
  
  //     let activeSubmissionId = localStorage.getItem('currentSubmissionId');
  //     if (!activeSubmissionId) {
  //       const newSubmissionDoc = await addDoc(collection(db, 'users', userId, 'Community_Minded_Business_Concept_Form'), { createdAt: new Date().toISOString() });
  //       activeSubmissionId = newSubmissionDoc.id;
  //       localStorage.setItem('currentSubmissionId', activeSubmissionId);
  //     }
  
  //     setSubmissionId(activeSubmissionId);
  //     const docRef = doc(db, 'users', userId, 'Community_Minded_Business_Concept_Form', activeSubmissionId);
  //     const docSnap = await getDoc(docRef);
  
  //     if (docSnap.exists()) {
  //       const data = docSnap.data();
  //       setSavedAnswers(data);
  
  //       if (currentStepData.stepTitle in data) {
  //         const stepData = data[currentStepData.stepTitle];
  //         const initialFormValues = {};
  
  //         currentStepData.formFields.forEach(field => {
  //           if (field.title in stepData) {
  //             initialFormValues[field.id] = stepData[field.title];
  //             if (field.title === 'logo') {
  //               setFile(stepData[field.title]);
  //             }
  //           }
  //         });
  
  //         setFormValues(initialFormValues);
  //       }
  //     }
  //   };
  
  //   fetchSavedAnswers();
  // }, [userId, currentStepData.stepTitle, formReset]);

  useEffect(() => {
  const fetchSavedAnswers = async () => {
    if (formReset) return;

    if (!submissionId) {
      const newSubmissionDoc = await addDoc(collection(db, 'users', userId, 'Community_Minded_Business_Concept_Form'), { createdAt: new Date().toISOString() });
      setSubmissionId(newSubmissionDoc.id);
      localStorage.setItem('currentSubmissionId', newSubmissionDoc.id);
    }

    const docRef = doc(db, 'users', userId, 'Community_Minded_Business_Concept_Form', submissionId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      setSavedAnswers(data);

      if (currentStepData.stepTitle in data) {
        const stepData = data[currentStepData.stepTitle];
        const initialFormValues = {};

        currentStepData.formFields.forEach(field => {
          if (field.title in stepData) {
            initialFormValues[field.id] = stepData[field.title];
            if (field.title === 'logo') {
              setFile(stepData[field.title]);
            }
          }
        });

        setFormValues(initialFormValues);
      }
    }
  };

  fetchSavedAnswers();
}, [userId, currentStepData.stepTitle, formReset, submissionId]);


  const handleFormFieldChange = (e, fieldId) => {
    const field = currentStepData.formFields.find(field => field.id === fieldId);
    const value = e.target.value;

    if (value.length <= field.maxChars) {
      setFormValues(prevValues => ({
        ...prevValues,
        [fieldId]: value
      }));
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

// Function to handle file upload to storage and getting the URL
const handleFileUpload = async (userId) => {
  if (!file) return null;

  const storageRef = ref(storage, `Community_Minded_Business_Concept_Form/uploads/ORGANIZATIONAL-DETAILS-draft-logo-or-official-logo/${userId}/${file.name}`);
  const uploadTask = uploadBytesResumable(storageRef, file);

  return new Promise((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      snapshot => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log(`Upload is ${progress}% done`);
      },
      error => {
        console.error("File upload error:", error);
        reject(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(downloadURL => {
          console.log("File available at", downloadURL);
          setLogoURL(downloadURL); // Set the URL to state
          resolve(downloadURL);
        });
      }
    );
  });
};

const handleFormSubmit = async (e) => {
  e.preventDefault();

  const newFormValues = {};
  const formFields = currentStepData.formFields;
  let allFieldsFilled = true;
  const errors = {};

  for (const field of formFields) {
    const fieldValue = formValues[field.id]?.trim();
    if (field.type === 'file') {
      if (!file) {
        allFieldsFilled = false;
        errors[field.id] = `${field.title} is required.`;
      }
    } else if (!fieldValue) {
      allFieldsFilled = false;
      errors[field.id] = `${field.title} is required.`;
    } else {
      newFormValues[field.title] = fieldValue;
    }
  }

  if (Object.keys(errors).length > 0) {
    setFormErrors(errors);
    return;
  }

  if (!allFieldsFilled) {
    setShowReviewPopup(true);
    setTimeout(() => {
      setShowReviewPopup(false);
    }, 2000);
    return;
  }

  try {
    // Upload file and get URL if applicable
    const fileURL = file ? await handleFileUpload(userId) : null;
    if (fileURL) {
      newFormValues['logo'] = fileURL; // Store under a consistent key
    }

    const sanitizedStepTitle = currentStepData.stepTitle;

    // Check if submissionId is valid, if not, create a new submission document
    let activeSubmissionId = submissionId;
    const docRef = doc(db, 'users', userId, 'Community_Minded_Business_Concept_Form', activeSubmissionId);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      // No document found or first submission, create a new submission ID
      const newSubmissionDoc = await addDoc(collection(db, 'users', userId, 'Community_Minded_Business_Concept_Form'), { createdAt: new Date().toISOString() });
      activeSubmissionId = newSubmissionDoc.id;
      setSubmissionId(activeSubmissionId);
      localStorage.setItem('currentSubmissionId', activeSubmissionId);
    }

    console.log(`Saving data for submission ID: ${activeSubmissionId}`);

    const submissionRef = doc(db, 'users', userId, 'Community_Minded_Business_Concept_Form', activeSubmissionId);
    await updateDoc(submissionRef, { [sanitizedStepTitle]: newFormValues });

    console.log("Form answers saved successfully!");

    setSavedAnswers(prevAnswers => ({
      ...prevAnswers,
      [sanitizedStepTitle]: newFormValues
    }));

    setFormSubmitted(true);
  } catch (error) {
    console.error("Failed to save form answers:", error);
  }
};
  
  const handleNextStepAfterReview = () => {
    setFormSubmitted(false);
    handleNextStep();
  };
  
  const handleBackFromReview = () => {
    setFormSubmitted(false);
    // Restore form values from savedAnswers
    const stepData = savedAnswers[currentStepData.stepTitle] || {};
    const initialFormValues = {};
  
    currentStepData.formFields.forEach(field => {
      if (field.title in stepData) {
        initialFormValues[field.id] = stepData[field.title];
        if (field.title === 'logo') {
          setFile(stepData[field.title]);
        }
      }
    });
  
    setFormValues(initialFormValues);
    setFormSubmitted(false);
  };
  

// Inside the handleRedirectToStart function
const handleRedirectToStart = async () => {
  const startStep = 12;
  const newSubmissionDoc = await addDoc(collection(db, 'users', userId, 'Community_Minded_Business_Concept_Form'), { createdAt: new Date().toISOString() });
  setSubmissionId(newSubmissionDoc.id);
  localStorage.setItem('currentSubmissionId', newSubmissionDoc.id);

  await updateUserProgress(userId, 'Community-Minded Business Concept Form', startStep);
  await updateDoc(doc(db, 'users', userId), { currentStep: startStep });
  navigate(`/survey/${startStep}`);

  setFormValues({});
  setFile(null);
  setFormErrors({});
  setFormSubmitted(false);
  setFormReset(true);
};

// Function to handle editing the current submission from the start
const handleEditSubmission = async () => {
  const startStep = 12; // Starting step or the initial step for editing
  const activeSubmissionId = localStorage.getItem('currentSubmissionId');
  
  // Reset form values for the submission
  const submissionRef = doc(db, 'users', userId, 'Community_Minded_Business_Concept_Form', activeSubmissionId);
  const docSnap = await getDoc(submissionRef);
  
  if (docSnap.exists()) {
    const data = docSnap.data();
    // Reset form values if needed; otherwise, just navigate to the start step
    setFormValues(data[startStep] || {});
    setFile(null);
    setFormErrors({});
    setFormSubmitted(false);
    setFormReset(true); // To skip fetching saved answers during the reset
  }
  
  // Update current step and redirect
  await updateDoc(doc(db, 'users', userId), { currentStep: startStep });
  navigate(`/survey/${startStep}`);
};

  
  
    //Reset the form values
    useEffect(() => {
      if (formReset) {
        setFormValues({});
        setFile(null);
        setFormErrors({});
        setFormReset(false); // Reset the formReset flag after clearing the form
      }
    }, [formReset]);

  return (
    <>
      {showReviewPopup && (
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-4 bg-white border border-gray-300 shadow-lg rounded-md z-50">
          <h4 className="text-red-600">
            <strong>Please fill in all the fields before submitting.</strong>
          </h4>
          <p>Some of your responses were incorrect.</p>
        </div>
      )}
      <TransitionGroup>
        <CSSTransition
          key={currentStep}
          timeout={500}
          classNames="slide"
        >
          <div>
            {currentStepData.id !== 19 ? (
              !formSubmitted ? (
                <>
                  <div>
                    <div className="text-2xl">{currentStepData.area}</div>
                  </div>
                  <StepHeader stepTitle={currentStepData.stepTitle} stepDescription={currentStepData.stepDescription} />
                  <form onSubmit={handleFormSubmit}>
                    {currentStepData.formFields.map((field, index) => (
                      <div key={index} className="mb-4">
                        <label htmlFor={field.id} className="block text-sm font-medium text-gray-700">{field.title}</label>
                        {field.type === 'file' ? (
                          <>
                            <input
                              type="file"
                              id={field.id}
                              name={`${currentStepData.stepTitle}-${field.id}`}
                              accept="image/png, image/jpeg"
                              className={`mt-1 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md ${formErrors[field.id] ? 'border-red-500' : ''}`}
                              onChange={handleFileChange}
                            />
                            {formValues[field.id] && (
                              <div>
                                <p>Uploaded File:</p>
                                <img src={logoURL} alt="Uploaded" className="mt-2 w-full max-w-xs" />
                              </div>
                            )}
                          </>
                        ) : field.type === 'number' ? (
                          <input
                            type="number"
                            id={field.id}
                            name={`${currentStepData.stepTitle}-${field.id}`}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            value={formValues[field.id] || ''}
                            onChange={(e) => handleFormFieldChange(e, field.id)}
                          />
                        ) : field.type === 'tel' ? (
                          <input
                            type="tel"
                            id={field.id}
                            name={`${currentStepData.stepTitle}-${field.id}`}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            value={formValues[field.id] || ''}
                            onChange={(e) => handleFormFieldChange(e, field.id)}
                          />
                        ) : field.type === 'url' ? (
                          <input
                            type="url"
                            id={field.id}
                            name={`${currentStepData.stepTitle}-${field.id}`}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            value={formValues[field.id] || ''}
                            onChange={(e) => handleFormFieldChange(e, field.id)}
                          />
                        ) : (
                          <textarea
                            id={field.id}
                            name={`${currentStepData.stepTitle}-${field.id}`}
                            rows="4"
                            className="mt-1 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md"
                            value={formValues[field.id] || ''}
                            onChange={(e) => handleFormFieldChange(e, field.id)}
                          />
                        )}
                        {formErrors[field.id] && (
                          <p className="text-red-500 text-sm mt-1">Please fill this field.</p>
                        )}
                        <div className="text-sm text-gray-500">
                          {formValues[field.id]?.length || 0}/{field.maxChars} characters
                        </div>
                      </div>
                    ))}
                    <button type="submit" className="mt-4 px-8 py-3 text-black border border-black font-semibold rounded-full hover:bg-amber-400 transition-colors">
                      Save / Continue
                    </button>
                    <button
                      type="button"
                      className="mt-4 px-8 py-3 text-black border border-black font-semibold rounded-full hover:bg-gray-400 transition-colors"
                      onClick={handlePreviousStep}
                    >
                      Back
                    </button>
                  </form>
                </>
              ) : (
                <SavedAnswersPage 
                  handleNextStep={handleNextStepAfterReview} 
                  nextStep={currentStepData.nextStep} 
                  userId={userId}
                  handlePreviousStep={handleBackFromReview} 
                  setFormValues={setFormValues} // Pass setFormValues to reset form values
                />
              )
            ) : (
              <>
                <div className="text-center p-8 border border-black rounded bg-white">
                  <h1 className="font-aileron font-bold text-3xl mb-5">Thank you for completing the form!</h1>
                  <p className='mb-5'>You can change or submit it any time, or print this form records</p>
                  <div className="md:flex md:text-center sm:block md:flex-row items-center align-center justify-center space-y-4 mt-4">
                  <button
                        onClick={handleEditSubmission}
                        className="mt-4 mr-3 px-8 py-3 text-black border border-black font-semibold rounded-full bg-white transition-colors"
                      >
                         <FontAwesomeIcon className="float-left mt-1 mr-2" icon={faFileEdit} />Edit Current Submission
                    </button>
                    <button
                      className="mt-4 px-8 py-3 text-black border border-black font-semibold rounded-full bg-white transition-colors" 
                      onClick={handleRedirectToStart} 
                    >
                      <FontAwesomeIcon className="float-left mt-1 mr-2" icon={faArrowLeft} /> Start new CMBC
                    </button>
                    <button
                      className="ml-2 mt-4 px-8 py-3 text-black border border-black font-semibold rounded-full hover:bg-amber-400 bg-white transition-colors"
                      onClick={() => generatePDF(savedAnswers, 'Community-Minded Business Concept Form Answers')}
                    >
                      Download PDF  <FontAwesomeIcon className="float-right mt-1 ml-2" icon={faFilePdf} />
                    </button>
                  </div>
                  <br />
                  ----- or -----
                  <br />
                  <br />
                  <AreaNavigator 
                    userId={userId} 
                    surveySteps={surveySteps} 
                    setCurrentStep={setCurrentStep}
                    currentStep={currentStep}
                    destination='Finances & Philanthropy'
                    area={area}
                    progress={progress}
                  />
                </div>
              </>
            )}
          </div>
        </CSSTransition>
      </TransitionGroup>
    </>
  );
};

export default CommunityForm;